// ------------------- 1. CONSTS ----------------------------------
// Client url and server url

// const url = 'https://gsbmeschdttnonprodaue.blob.core.windows.net/';
const serverUrl = process.env.NODE_ENV === 'production' ? 'https://sch-dtt-dev.ihealthe.org/api' : 'http://localhost:3001';
const clientUrl = process.env.NODE_ENV === 'production' ? 'https://sch-dtt-dev.ihealthe.org' : 'http://localhost:3000';

// const serverUrl = 'http://localhost:3001';

const PATIENT = 'Patient';
const PRACTITIONER = 'Practitioner';

const loginFHIRPage = '/LoginFHIR';
const loginFailRedirectUrl = '/LoginParse';
const loginSuccessRedirectUrl = '/PatientList';
const logoutEndpoint = '/';

// BACKEND URL STRINGS
const loginExpressUrl = serverUrl + '/LoginPractitioner';
const getPatientListUrl = serverUrl + '/getPatientList';
const userInfoUrl = serverUrl + '/UserInfo';
const questionnaireUrl = serverUrl + '/Questionnaire';
const questionnaireResponseUrl = serverUrl + '/QuestionnaireResponse';
const observationUrl = serverUrl + '/Observation';
const logoutUrl = serverUrl + '/Logout';
const patientUrl = serverUrl + '/Patient';


const questionnaireNames = {
  Patient: "DPCSTTPatientVersionQuestionnaire4/11",
  Practitioner: "DPCSTTQuestionnaire26/09",
  Recommendation: "DPCSTTRecommendationQuestionnaire26/08"
};

/*
USE THIS ENDPOINT TO FIND PUBLIC KEY AND END_SESSION_ENDPOINT
https://digitaltriagetool1b2c.b2clogin.com/digitaltriagetool1b2c.onmicrosoft.com/b2c_1_sisu/v2.0/.well-known/openid-configuration
*/

// ================ 2. MSAL Object Stuff ==============//
// Configured for "schdttb2c"
const msalConfig = {
  auth: {
    clientId: 'f9cfccdc-4a90-409a-9669-b1ff84f7eff4', // Bailey's "webapp" App Registration client ID
    authority: 'https://schdttgsbmeb2c.b2clogin.com/schdttgsbmeb2c.onmicrosoft.com/B2C_1_sisu',
    validateAuthority: false,
    postLogoutRedirectUri: clientUrl
    // redirectUri: loginFHIRPage //Ideally want this, it's just not working for some reason.
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" to save cache in cookies to address trusted zones limitations in IE (see: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/Known-issues-on-IE-and-Edge-Browser)
  },
};

/**
 * Scopes you enter here will be consented once you authenticate. For a full list of available authentication parameters,
 * visit https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/modules/_authenticationparameters_.html
 */
const loginRequest = {
  scopes: ['openid', 'offline_access', 'email'],
};

// Add here scopes for access token to be used at the API endpoints.
const tokenRequest = {
  scopes: ['https://schdttgsbmeb2c.onmicrosoft.com/webapi/practitioner'],
};

module.exports = {
  PATIENT,
  PRACTITIONER,
  serverUrl,
  loginFailRedirectUrl,
  loginSuccessRedirectUrl,
  logoutEndpoint,
  questionnaireNames,
  loginFHIRPage,
  loginExpressUrl,
  getPatientListUrl,
  userInfoUrl,
  questionnaireUrl,
  questionnaireResponseUrl,
  observationUrl,
  logoutUrl,
  patientUrl,
  msalConfig,
  loginRequest,
  tokenRequest,
};



// WEBPACK FOOTER //
// ./src/config-client.js